import { styled } from "styled-components";

import {
    colorCSS,
    cssColorsFromBackgroundField,
    h5,
    minWidth,
    radius,
    shadow
} from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";
import { getColorInitial } from "../../utils";

export const Callout = styled.div<{ mediaOnRight?: boolean }>`
    ${cssColorsFromBackgroundField({ color: "N0" })}
    ${redundantCssFromKebab("align-items", "center")}
    ${redundantCssFromKebab("border-radius", `${radius.small}`)}
    ${redundantCssFromKebab("box-shadow", `${shadow.normal}`)}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-direction", "column")}
    ${redundantCssFromKebab("gap", "2rem")}
    ${redundantCssFromKebab("margin", "0 auto")}
    ${redundantCssFromKebab("max-width", "100%")}
    ${redundantCssFromKebab("padding", "1.5rem")}
    ${redundantCssFromKebab("text-align", "left")}
    
    @media (min-width: 576px) {
        max-width: 540px;
    }

    @media (min-width: 768px) {
        max-width: 720px;
    }

    @media ${minWidth.lg} {
        ${redundantCssFromKebab("flex-direction", "row")}
        ${redundantCssFromKebab("padding", "2rem")}
        max-width: 960px;
        ${({ mediaOnRight }) => mediaOnRight && "flex-direction: row-reverse;"}
    }

    @media (min-width: 1200px) {
        max-width: 1140px;
    }

    @media (min-width: 1400px) {
        max-width: 1320px;
    }
`;

export const CalloutMedia = styled.div`
    @media ${minWidth.lg} {
        ${redundantCssFromKebab("width", "55%")}
    }
`;

export const CalloutHeading = styled.div`
    ${redundantCssFromKebab("align-items", "center")}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("gap", "1rem")}
    ${redundantCssFromKebab("margin-bottom", "1.5rem")}

    svg {
        ${redundantCssFromKebab("display", "block")}
        ${redundantCssFromKebab("height", "auto")}
        ${redundantCssFromKebab("width", "2rem")}
    }

    h3 {
        ${h5}
        ${redundantCssFromKebab("margin", "0")}
    }
`;

export const CalloutIcon = styled.div<{
    $color?:
        | "Blue"
        | "Green"
        | "Magenta"
        | "Purple"
        | "Red"
        | "Teal"
        | "Yellow";
}>`
    display: none;
    ${({ $color }) =>
        $color &&
        `
        @media ${minWidth.lg} {
            color: ${colorCSS(`${getColorInitial($color)}200`)};
            display: block;
        }
    `}
`;

export const CalloutText = styled.div`
    p:last-child {
        ${redundantCssFromKebab("margin-bottom", "0")}
    }
    @media ${minWidth.lg} {
        ${redundantCssFromKebab("padding", "0 2rem")}
        ${redundantCssFromKebab("width", "45%")}
    }
`;
